/**
 * Allow undefined and single values as shorthands for arrays.
 * This is useful for making concise configurations.
 */
export function many(x) {
  if (x === undefined) return [];
  // eslint-disable-next-line unicorn/no-instanceof-array
  if (x instanceof Array) return x;
  return [x];
}